import { buildSelector } from '@/shared/lib/store';

export const [useGetIsTradingPlatformConnected] = buildSelector(
    (state) =>
        state.tradingPlatformSession.accountId !== null &&
        state.tradingPlatformSession.connectionType !== null,
);
